
    import { Component, Prop, Vue } from 'vue-property-decorator';

    @Component
    export default class FilterContentItem extends Vue {
        @Prop({ default: '' }) readonly title!: string;
        @Prop({ default: false }) readonly initialOpen!: boolean;
    }
